import React, { useEffect, useRef } from "react";
import { useIsInViewport, useWindowDimensions } from "../../../hooks";
import DocumentScrollPagePane from "./DocumentScrollPagePane";

export default function ScrollSectionPagePane({ partNumber, pageNumber, pageCount, documentDimensions, isSectionInViewport, onComeIntoVisibility, setPageNumber, children, onToggleZoom, pdfRendered }) {
    const containerRef = useRef(null);
    const [isInViewport, intersectionRatio] = useIsInViewport(containerRef);
    const { height: viewportHeight } = useWindowDimensions();

    const pageChangeHeightThreshold = (viewportHeight - 139) / 2;

    useEffect(() => {
        containerRef.current.id = `page=${pageNumber}`
    }, [containerRef?.current]);

    useEffect(() => {
        if (isInViewport && intersectionRatio * documentDimensions.documentHeight >= pageChangeHeightThreshold) {
            onComeIntoVisibility(pageNumber);
        }
    }, [isInViewport, intersectionRatio, pageChangeHeightThreshold, documentDimensions.documentHeight, pageNumber, partNumber, pageCount]);

    return (
        <DocumentScrollPagePane
            partNumber={partNumber}
            pageNumber={pageNumber}
            pageCount={pageCount}
            documentDimensions={documentDimensions}
            isInViewport={isInViewport}
            ref={containerRef}
            onToggleZoom={onToggleZoom}
            pdfRendered={pdfRendered}
        >
            {isSectionInViewport && !!children ? children : null}
        </DocumentScrollPagePane>
    );
}